import { Button, Grid, Stack, useTheme } from "@mui/material";
import React, { useEffect, useState } from "react";
import PropTypes from 'prop-types';
import TextInput from "@/common/components/text-input/text-input";
import AnimateButton from "@/from-theme/components/@extended/AnimateButton";
import { FormattedMessage } from "react-intl";
import { apiStatuses } from "@/store/api/constants";
import Spinner from "@/common/components/spinner/spinner";
import ErrorInPage from "@/common/components/error-in-page/error-in-page";
import useGetPlantMasterByDivision from "@/common/hooks/useGetPlantByDivision";
import useCreateEditSchemeNonEligibleApproval from "./hooks/useCreateEditSchemeNonEligibleApproval";
import CustomTable from '@/common/components/CustomTableNew/CustomTable';
import useGetDropdownListOptions from "@/common/hooks/useGetDropdownListMaster";
import SchemeStatusService from "@/service/Scheme/SchemeStatusService";
import InarrayCheckComponent from "@/common/helpers/InarrayCheckComponent";
import { commonColumns } from "./constants/constants";
import { commonColumns1 } from "./constants/constants1";
import { commonColumns2 } from "./constants/constants2";

function CreateEditSchemeNonEligibleApproval({ isEditMode }) {

  const { averageRuleOptions, getDropdownListLoading } = useGetDropdownListOptions();

  const mappedAverageRuleOptions = averageRuleOptions.map((opt) =>
    ({ label: opt.label, id: opt.id }));

  const { getPlantsByDivisionOptions: plantsData,
    getPlantsByDivision: getPlant,
    getPlantsByDivisionLoading: plantsLoading
  } = useGetPlantMasterByDivision("plant");

  const {
    values, formik, getEditSchemesListMasterStatus,
    getEditSchemesListMasterErrMsg, saveCompetitorMasterStatus,
    updateCompetitorMasterStatus, goBack
  } = useCreateEditSchemeNonEligibleApproval({ isEditMode, getPlant });

  const theme = useTheme();

  const [avgRule, setAvgRule] = useState(false)
  const [isSalesDataLoading, setIsSalesDataLoading] = useState(false);
  const [rowSelection, setRowSelection] = useState({});

  const {
    noOfCustomerCount, schemeName, productId, schemeMonth,
    schemeYear, schemeId, childData, groupId, totalSales
  } = values;

  useEffect(() => {
    const selectedRowIndices = Object.keys(rowSelection).map(Number)
    const selectedRowsData = selectedRowIndices.map(index => values.childData[index])
    console.log('Selected Rows Data:', selectedRowsData)
    console.log('Selected Rows Data: - selectedRowIndices', selectedRowIndices)
    console.log('onSubmit-values groupId', groupId)
    if (avgRule) {
      values.avgRuleOverAll = 1
      if (groupId) {
        values.avgRuleOverAllGroupId = groupId.id
      } else {
        values.avgRuleOverAllGroupId = ''
      }
    } else {
      values.avgRuleOverAll = 0
      values.avgRuleOverAllGroupId = ''
    }

    if (values.childData && values.childData.length > 0 && selectedRowsData
      && selectedRowsData.length > 0) {
      values.childData.map((vk, lk) => {
        if (InarrayCheckComponent(lk, selectedRowIndices)) {
          vk.selected = 1
        } else {
          vk.selected = 0
        }
      })
    }
  }, [rowSelection, values.childData, groupId]);

  const isPending = [saveCompetitorMasterStatus,
    updateCompetitorMasterStatus,].includes(apiStatuses.pending);

  // const {
  //   noOfCustomerCount, schemeTotal, schemeName, productId, schemeTypeName, schemeMonth, 
  //   schemeYear, schemeId, productName, divisionName, childData, groupId
  // } = values;

  const handleActionChange = (rowId, value) => {
    const newChildData = values.childData.map((row) => {
      if (row.id === rowId) {
        return { ...row, action: value };
      }
      return row;
    });
    formik.setFieldValue('childData', newChildData);
  };

  const actionOptions = [
    { label: 'Approve', value: 'approved' },
    { label: 'Reject', value: 'rejected' },
  ];

  const handleStatusChange = (rowId, value) => {
    const newChildData = values.childData.map((row) => {
      if (row.id === rowId) {
        return { ...row, status: value };
      }
      return row;
    });
    formik.setFieldValue('childData', newChildData);
  }

  const handleAvgRuleChange = (rowId, value) => {
    const newChildData = values.childData.map((row) => {
      if (rowId && row.id === value.id) {
        return { ...row, avgRule_index: rowId.label, avgRule_id: rowId.id }
      } else if (!rowId && row.id === value.id) {
        return { ...row, avgRule_index: '', avgRule_id: '' }
      }
      return row;
    });
    formik.setFieldValue('childData', newChildData);
  }

  const changeValuesInput = (e) => {
    if (e == 1) { setAvgRule(true) } else { setAvgRule(false) }
    values.groupId = ''
  }

  const handleButtonClick = (rowData) => {
    if (!rowData.avgRule_id && !rowData.avgRule_index && (!avgRule ||
      (avgRule && !groupId)) && !groupId) {
      alert('Average Rule must be selected..!')
      return false
    }

    let avgRuleIdSelected = ''
    let avgRuleLabelSelected = ''
    if (rowData.avgRule_id && rowData.avgRule_index) {
      avgRuleIdSelected = rowData.avgRule_id
      avgRuleLabelSelected = rowData.avgRule_index
    } else {
      avgRuleIdSelected = groupId.id
      avgRuleLabelSelected = groupId.label
    }
    console.log(avgRuleIdSelected, 'handleButtonClick-avgRuleIdSelected')
    console.log(avgRuleLabelSelected, 'handleButtonClick-avgRuleLabelSelected')

    // const dates = dateFetch(avgRuleIdSelected,avgRuleLabelSelected)

    // let fromDate = dates[0]
    // let toDate = dates[1]
    // let salesOrg = 'FD00'
    let customerNo = rowData.customerCode

    console.log(customerNo, 'sapFormValues-customerNo')
    // console.log(salesOrg,'sapFormValues-salesOrg')
    // console.log(fromDate,'sapFormValues-fromDate')
    // console.log(toDate,'sapFormValues-toDate')

    // RakeTripsheetSapService.getFnrVendorDeliveryData(f__no,v__code).then((res) => {

    setIsSalesDataLoading(true);
    SchemeStatusService.getSapSchemeSalesData(customerNo, avgRuleIdSelected, productId).
      then((res) => {
        console.log(res, 'getSapSchemeSalesData')

        if (res.status == 200) {
          if (res.data.SAP_STATUS == 1) {
            let salesValue = res.data.totalTonage ? res.data.totalTonage : 0
            const newChildData = values.childData.map((row) => {

              if (row.id === rowData.id) {
                return { ...row, avgSales_index: salesValue }
              }
              return row;
            });
            formik.setFieldValue('childData', newChildData);
            console.log(newChildData, 'newChildData')
          } else {
            alert(res.data.SAP_REMARKS)
            const newChildData = values.childData.map((row) => {

              if (row.id === rowData.id) {
                return { ...row, avgSales_index: '' }
              }
              return row;
            });
            formik.setFieldValue('childData', newChildData);
            console.log(newChildData, 'newChildData')
          }
        } else {
          alert('Something Went Wrong..')
        }

        // let res_data = res.status == '200' ? res.data.response.data : []
        // setExistingBudgetData(res_data)

      }).finally(() => {
        setIsSalesDataLoading(false);
      });
  };

  const statusOptions = [
    { label: 'Active', value: 'active' },
    { label: 'Inactive', value: 'inactive' },
  ];

  const tableColumns = commonColumns({
    theme, isParentColumns: true, handleActionChange, actionOptions,
    handleAvgRuleChange, handleStatusChange, statusOptions,
    averageRuleOptions: mappedAverageRuleOptions, formik, handleButtonClick, avgRule, groupId
  });

  const tableRequestForEligibleColumns = commonColumns1({
    theme, isParentColumns: true, handleActionChange, actionOptions,
    handleAvgRuleChange, handleStatusChange, statusOptions,
    averageRuleOptions: mappedAverageRuleOptions, formik, handleButtonClick, avgRule, groupId
  });

  const tableRequestEligibleColumns = commonColumns2({
    theme, isParentColumns: true, handleActionChange,
    actionOptions, handleAvgRuleChange, handleStatusChange,
    statusOptions, averageRuleOptions: mappedAverageRuleOptions,
    formik, handleButtonClick, avgRule, groupId
  });

  const customerCountFinder = (type) => {
    let data = values.childData;
    if (data && data.length > 0) {
      if (type == 1) { /* Eligible Customers */
        // Added 'test &&' to ensure the object exists before checking properties
        let filtered_data = data.filter((test) => test?.schemeStatus == 1
          && test?.eligibleStatus == 1);
        return filtered_data.length || 0;
      } else if (type == 2) { /* Recommended Customers */
        let filtered_data = data.filter((test) => test?.schemeStatus == 1
          && test?.eligibleStatus == 3);
        return filtered_data.length || 0;
      } else if (type == 3) { /* Non Eligible Customers */
        let filtered_data = data.filter((test) => test?.schemeStatus != 1);
        return filtered_data.length || 0;
      }
    }
    return 0;
  };


  return (
    <>
      {isSalesDataLoading && <Spinner />}
      {
        getEditSchemesListMasterStatus === apiStatuses.pending && isEditMode
        && <Spinner />
      }
      {getEditSchemesListMasterStatus === apiStatuses.rejected && isEditMode && (
        <ErrorInPage message={getEditSchemesListMasterErrMsg} />
      )}
      {(getEditSchemesListMasterStatus === apiStatuses.succeeded || !isEditMode) &&
        <form onSubmit={formik.handleSubmit}>
          <Grid container spacing={2}>
            {/* <Stack direction="row" gap={2}> */}
            <Grid item xs={12} sm={6} md={4} lg={3}>
              <TextInput
                placeholder="scheme-name"
                size="small"
                fullWidth
                value={schemeName}
                inputLabel="scheme-name"
                InputProps={{ readOnly: true }}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={4} lg={3}>
              <TextInput
                placeholder="scheme-id"
                size="small"
                fullWidth
                value={schemeId}
                inputLabel="scheme-id"
                InputProps={{ readOnly: true }}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={4} lg={3}>
              <TextInput
                placeholder="scheme-period"
                size="small"
                fullWidth
                value={`${schemeMonth} - ${schemeYear}`}
                inputLabel="scheme-period"
                InputProps={{ readOnly: true }}
              />
            </Grid>

            {/* </Stack>  */}
            <Grid item xs={12} sm={6} md={4} lg={3}>
              <TextInput
                placeholder="no-of-customers"
                size="small"
                fullWidth
                value={noOfCustomerCount}
                formik={formik}
                inputLabel="total-customers-count"
                InputProps={{ readOnly: true }}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={4} lg={3}>
              <TextInput
                placeholder="no-of-customers"
                size="small"
                fullWidth
                value={customerCountFinder(1)}
                formik={formik}
                inputLabel="eligible-customers-count"
                InputProps={{ readOnly: true }}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={4} lg={3}>
              <TextInput
                placeholder="no-of-customers"
                size="small"
                fullWidth
                value={customerCountFinder(2)}
                formik={formik}
                inputLabel="request-for-eligible-customers-count"
                InputProps={{ readOnly: true }}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={4} lg={3}>
              <TextInput
                placeholder="no-of-customers"
                size="small"
                fullWidth
                value={customerCountFinder(3)}
                formik={formik}
                inputLabel="non-eligible-customers-count"
                InputProps={{ readOnly: true }}
              />
            </Grid>

            <Grid item xs={12}>
              {/* <div style={{ minWidth: '500px' }}> */}
              <div>
                <h3 style={{ marginLeft: '5%', color: 'green' }}><u>Eligible Customers</u></h3>
                <CustomTable
                  data={childData && childData.length > 0 ? childData.
                    filter(option => option.eligibleStatus == 1) : []}
                  columns={tableRequestEligibleColumns}
                  apiStatus={getEditSchemesListMasterStatus}
                  apiErrorMsg={getEditSchemesListMasterErrMsg}
                  initialPageSize={10}
                // rowSelection={rowSelection}
                // setRowSelection={setRowSelection}
                />
              </div>
              <div>
                <h3 style={{ marginLeft: '5%', color: 'blue' }}><u>Recommanded Customers</u></h3>
                <CustomTable
                  data={childData && childData.length > 0 ? childData.
                    filter(option => option.eligibleStatus == 3) : []}
                  columns={tableRequestForEligibleColumns}
                  apiStatus={getEditSchemesListMasterStatus}
                  apiErrorMsg={getEditSchemesListMasterErrMsg}
                  initialPageSize={10}
                // rowSelection={rowSelection}
                // setRowSelection={setRowSelection}
                />
              </div>
              <div>
                <h3 style={{ marginLeft: '5%', color: 'red' }}><u>Non Eligible Customers</u></h3>
                <CustomTable
                  data={childData && childData.length > 0 ? childData.
                    filter(option => (option.eligibleStatus == null ||
                      option.eligibleStatus == 2) || (option.eligibleStatus == null)) : []}
                  columns={tableColumns}
                  apiStatus={getEditSchemesListMasterStatus}
                  apiErrorMsg={getEditSchemesListMasterErrMsg}
                  initialPageSize={10}
                // rowSelection={rowSelection}
                // setRowSelection={setRowSelection}
                />
              </div>
            </Grid>


            {/* <Grid item xs={12} sm={6} md={4} lg={3}>
              <SwitchInput
                inputLabel="activeStatus"
                leftLabel="inactive"
                rightLabel="active"
                value={activeStatus}
                formik={formik}
                name="activeStatus"
              />
            </Grid> */}
            <Grid item xs={12}>
              <Stack direction="row" spacing={3} className="btn-end">
                <AnimateButton>
                  <Button variant="contained" color="warning" onClick={goBack}>
                    <FormattedMessage id="back" />
                  </Button>
                </AnimateButton>
                <AnimateButton>
                  <Button type="submit" variant="contained" disabled={isPending}>
                    <FormattedMessage id="save" />
                  </Button>
                </AnimateButton>
              </Stack>
            </Grid>
          </Grid>
        </form>
      }
    </>
  );
}

CreateEditSchemeNonEligibleApproval.propTypes = {
  isEditMode: PropTypes.bool,
};

CreateEditSchemeNonEligibleApproval.defaultProps = {
  isEditMode: false,
};

export default CreateEditSchemeNonEligibleApproval;
